// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3eRPM","content":"LayoutSettings_content__mILxV"};